import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=12ce9f66&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=ts&"
export * from "./pie.vue?vue&type=script&lang=ts&"
import style0 from "./pie.vue?vue&type=style&index=0&id=12ce9f66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce9f66",
  null
  
)

export default component.exports